/**
 * @fileoverview Builds the grouped view-model for NotificationFormView.
 * @module pages/notificationForm/buildNotificationFormViewModel
 */
import { getNotificationFormLocale } from "./notificationFormLocale.js";

/** @param {Object} ctx @param {Object} handlers @returns {Object} */
export const buildNotificationFormViewModel = (ctx, handlers) => ({
  allowed: ctx.allowed,
  t: ctx.t,
  navigate: ctx.navigate,
  locale: getNotificationFormLocale(ctx.i18n.language),
  formData: ctx.formData,
  setFormData: ctx.setFormData,
  imagePreview: ctx.imagePreview,
  imageRef: ctx.imageRef,
  selectSubsectorRef: ctx.selectSubsectorRef,
  sectors: ctx.sectors,
  subsectors: ctx.subsectors,
  setSubsectors: ctx.setSubsectors,
  showError: ctx.showError,
  loading: ctx.loading,
  isCalendarOpen: ctx.isCalendarOpen,
  setIsCalendarOpen: ctx.setIsCalendarOpen,
  error: ctx.error,
  notificationTypeOptions: ctx.notificationTypeOptions,
  companySizeOptions: ctx.companySizeOptions,
  companyGeneralActivityOptions: ctx.companyGeneralActivityOptions,
  handlers,
});
